import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import moment from "moment";
import DateForm from "../../Components/DateForm/DateForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import "./PersonalDetails.css";
import { insertMemberpersonaldetaiks, getPersonalDetailsByMemberId, CommonDropdownData, GetMultipleDropdownData } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import validator from "validator";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { DropdownTypeId } from "../../Helpers/Enums/DropdownTypeId";
import { Encrypt } from "../../Helpers/Cryptography/Crypto";
import { GetDecryptedMemberIdFromLocalStorage, SetEncryptedMemberIdToLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { randomDate, randomEmail, randomMobile, randomNumber, randomString } from "../../Helpers/Common";
import { enableTestData } from "../../Helpers/Constants/Constants";
import { setIsApplicationTypeOthers, setMemberRegistrationUserType } from "../../Redux/Actions/MemberRegistrationActions";
import { useDispatch, useSelector } from "react-redux";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { GetMultipleDropdownDataResponseModel } from "../../Models/GetMultipleDropdownDataResponseModel";
import { MemberRegistrationUserType } from "../../Helpers/Enums/MemberRegistrationUserType";

const PersonalDetails = (props) => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [disabled, setDisabled] = React.useState(false);
  const [disabledToken, setDisabledToken] = React.useState(false);
  const [data, setData] = React.useState({
    tokenNumber: null,
    typeOfApplicant: null,
    firstName: "",
    middleName: "",
    lastName: "",
    dob: null,
    //doj: moment("").format("YYYY-MM-DD"),
    // doc: moment("").format("YYYY-MM-DD"),
    doj: null,
    doc: null,
    mobileNumber: null,
    email: "",
    title: null,
    gender: null,
    maritialStatus: null,
    birthCity: "",
    state: null,
    nationality: null,
    religion: null,
    serviceYears: null,
    careOf: "",
    street: "",
    secondAddLine: "",
    postalCode: "",
    district: "",
    region: null,
    country: null,
  });
  const [error, setError] = React.useState<any>({});
  const [statusData, setStatusData] = React.useState(props?.statusData);

  const [titleDropData, setTitleDropData] = React.useState([]);
  const [genderDropData, setGenderDropData] = React.useState([]);
  const [maritialStatusDropData, setMaritialStatusDropData] = React.useState([]);
  const [nationalityDropData, setNationalityDropData] = React.useState([]);
  const [religionDropData, setReligionDropData] = React.useState([]);
  const [districtDropData, setDistrictDropData] = React.useState([]);
  const [regionDropData, setRegionDropData] = React.useState([]);
  const [stateDropData, setStateDropData] = React.useState([]);
  const [countryDropData, setCountryDropData] = React.useState([]);
  const [applicantTypeDropData, setApplicantTypeDropData] = React.useState([]);

  const memberid = GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";

  // localStorage.clear()

  const { selectNextTab, selectPreviousTab } = props;

  const checkApplicantType = useSelector((state) => state);

 
  React.useEffect(() => {
    getMultipleDropdownData();
    // getTitleData();
    // getGenderData();
    // getMaritialStatusData();
    // getReligionData();
    // getRegionData();
    // getStateData();
    // getCountryData();
    // getNationalityData();
    // getApplicantTypeData();
  }, []);

  React.useEffect(() => {
    if (
      titleDropData &&
      genderDropData &&
      maritialStatusDropData &&
      religionDropData &&
      regionDropData &&
      stateDropData &&
      countryDropData &&
      nationalityDropData &&
      applicantTypeDropData
    ) {
      getPersonalDetails();
    }
  }, [
    titleDropData,
    genderDropData,
    maritialStatusDropData,
    religionDropData,
    regionDropData,
    stateDropData,
    countryDropData,
    nationalityDropData,
    applicantTypeDropData,
  ]);

  const onChange = (key, value) => {
    if (key == "state") {
      const region = stateDropData.find((sdd) => sdd?.label?.toLowerCase()?.trim() === value?.label?.toLowerCase()?.trim());
      setData({ ...data, state: value, region: region });
    } else if (key == "doj") {
      // Your target date
      const targetDate = moment(value, "YYYY-MM-DD");

      // Current date
      const currentDate = moment();

      // Calculate the number of years
      const years = currentDate.diff(targetDate, "years");

      // Round up to the nearest whole number
      const roundedYears = Math.ceil(years);

      setData({ ...data, doj: value, serviceYears: roundedYears });

      setError({ [data.doj]: null });
    } else {
      if (key === "typeOfApplicant") {
        dispatch(setMemberRegistrationUserType(value.value));
      }
      setData({ ...data, [key]: value });
    }
  };

  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    if (data.tokenNumber == null || data.tokenNumber == undefined) {
      errorObj = {
        ...errorObj,
        [data.tokenNumber]: "This field is required",
      };
    }

    if (data.typeOfApplicant == "" || data.typeOfApplicant == null) {
      errorObj = {
        ...errorObj,
        [data.typeOfApplicant]: "This field is required",
      };
    }
    if (data.firstName == "") {
      errorObj = {
        ...errorObj,
        [data.firstName]: "This field is required",
      };
    }
    if (data.middleName == "") {
      errorObj = {
        ...errorObj,
        [data.middleName]: "This field is required",
      };
    }
    if (data.lastName == "") {
      errorObj = {
        ...errorObj,
        [data.lastName]: "This field is required",
      };
    }
    if (data.dob == "" || data.dob == "Invalid date" || data.dob == null) {
      errorObj = {
        ...errorObj,
        [data.dob]: "This field is required",
      };
    }
    if (data.doj == "" || data.doj == "Invalid date" || data.doj == null) {
      errorObj = {
        ...errorObj,
        [data.doj]: "This field is required",
      };
    }
    if (data.doc == "" || data.doc == "Invalid date" || data.doc == null) {
      errorObj = {
        ...errorObj,
        [data.doc]: "This field is required",
      };
    }
    // if (data.doj && data.dob && moment(data.doj).isBefore(moment(data.dob))) {
    //   // If DOJ is before DOB, add an error
    //   errorObj = {
    //     ...errorObj,
    //     [data.doj]: "Date of Joining cannot be less than Date of Birth",
    //   };
    // } else
    if (data.doj && data.dob) {
      // Calculate the difference in years between DOJ and DOB
      const yearsDifference = moment(data.doj).diff(moment(data.dob), "years");

      // If the difference is less than 17, add an error
      if (yearsDifference < 18) {
        errorObj = {
          ...errorObj,
          [data.doj]: "Date of Joining should be at least 18 years after Date of Birth",
        };
      }
    }
    if ((data.doc && data.dob && moment(data.doc).isBefore(moment(data.dob))) || (data.doc && data.doj && moment(data.doc).isBefore(moment(data.doj)))) {
      errorObj = {
        ...errorObj,
        [data.doc]: "Date of Confirmation cannot be less that Date of Birth and Date of Joining",
      };
    }
    if (data.mobileNumber == null) {
      errorObj = {
        ...errorObj,
        [data.mobileNumber]: "This field is required",
      };
    } else if (data.mobileNumber.length != 10) {
      errorObj = {
        ...errorObj,
        [data.mobileNumber]: "Mobile number should be 10 digit",
      };
    }
    if (data.title == "" || data.title == null) {
      errorObj = {
        ...errorObj,
        [data.title]: "This field is required",
      };
    }
    if (data.gender == "" || data.gender == null) {
      errorObj = {
        ...errorObj,
        [data.gender]: "This field is required",
      };
    }

    if (data.maritialStatus == "" || data.maritialStatus == null) {
      errorObj = {
        ...errorObj,
        [data.maritialStatus]: "This field is required",
      };
    }
    if (data.state == "" || data.state == null) {
      errorObj = {
        ...errorObj,
        [data.state]: "This field is required",
      };
    }
    if (data.nationality == "" || data.nationality == null) {
      errorObj = {
        ...errorObj,
        [data.nationality]: "This field is required",
      };
    }
    if (data.religion == "" || data.religion == null) {
      errorObj = {
        ...errorObj,
        [data.religion]: "This field is required",
      };
    }
    // if (data.region == "" || data.region == null) {
    //   errorObj = {
    //     ...errorObj,
    //     [data.region]: "This field is required",
    //   };
    // }
    if (data.country == "" || data.country == null) {
      errorObj = {
        ...errorObj,
        [data.country]: "This field is required",
      };
    }

    if (data.birthCity == "") {
      errorObj = {
        ...errorObj,
        [data.birthCity]: "This field is required",
      };
    }

    if (data.email == "") {
      errorObj = {
        ...errorObj,
        ["emailvalidation"]: "This field is required",
      };
    }
    // if (data.serviceYears == "") {
    //   errorObj = {
    //     ...errorObj,
    //     [data.serviceYears]: "This field is required",
    //   };
    // }
    if (data.careOf == "") {
      errorObj = {
        ...errorObj,
        [data.careOf]: "This field is required",
      };
    }
    if (data.street == "") {
      errorObj = {
        ...errorObj,
        [data.street]: "This field is required",
      };
    }
    if (data.secondAddLine == "") {
      errorObj = {
        ...errorObj,
        [data.secondAddLine]: "This field is required",
      };
    }
    if (data.postalCode == "") {
      errorObj = {
        ...errorObj,
        [data.postalCode]: "This field is required",
      };
    }
    if (data.district == "") {
      errorObj = {
        ...errorObj,
        [data.district]: "This field is required",
      };
    }

    // if (data.serviceYears == "0" || data.serviceYears == 0) {
    //   notify(
    //     ToastType.Error,
    //     "You're not eligible for Credit Society Membership as your actual year of service in Mahindra is less than 1 year"
    //   );
    //   return null;
    // }

    if (Object.keys(errorObj).length === 0) {
      //
      showLoader();
      // const checkpersonaldetails = await getPersonalDetails();
      // console.log(checkpersonaldetails);
      // if (
      //   checkpersonaldetails === undefined ||
      //   checkpersonaldetails === null ||
      //   Object.keys(checkpersonaldetails).length === 0
      // ) {
      let param = {
        TokenNo: String(data.tokenNumber),
        ApplicantType: data.typeOfApplicant.value,
        FirstName: data.firstName,
        MiddleName: data.middleName,
        LastName: data.lastName,
        DateOfBirth: moment(data.dob).format("YYYY-MM-DD"),
        DateOfJoining: moment(data.doj).format("YYYY-MM-DD"),
        DateOfConfirmation: moment(data.doc).format("YYYY-MM-DD"),
        ContactNo: String(data.mobileNumber),
        EmailId: data.email,
        Title: data.title?.value || null,
        Gender: data.gender?.value ? data.gender.value : null,
        MaritialStatus: data.maritialStatus?.value ? data.maritialStatus.value : null,
        BirthCity: data.birthCity,
        State: data.state?.value ? data.state.value : null,
        Nationality: data.nationality?.value ? data.nationality.value : null,
        Religion: data.religion?.value ? data.religion.value : null,
        ActualServiceYears: data.serviceYears,
        CareOf: data.careOf,
        Street: data.street,
        AddLineSecond: data.secondAddLine,
        PostalCode: data.postalCode,
        District: data.district,
        Region: data.region?.value ? data.region.value : null,
        Country: data.country?.value ? data.country.value : null,
        IsUpdate: false,
      };
      if (memberid) {
        param["MemberId"] = memberid;
        param.IsUpdate = true;
      }
      //  console.log(param)
      const insertData = await APICall(insertMemberpersonaldetaiks, param);
      
      // console.log(insertData);
      if(insertData?.Message == "Ok" && insertData?.Data === 2){
        hideLoader();
        notify(ToastType.Error, "EmailId Already Exists!");
      }
      else if (insertData?.Message == "Ok" && insertData?.Data != null) {
        // localStorage.setItem("MemberId", encryptedMemberId);
        SetEncryptedMemberIdToLocalStorage(insertData.Data.toString());
        hideLoader();
        selectNextTab();

        let applicantType = applicantTypeDropData.find((d) => d.value === data.typeOfApplicant.value);

        if (applicantType && (applicantType.label.includes("Other") || applicantType.label.includes("other"))) {
          dispatch(setIsApplicationTypeOthers(true));
        } else {
          dispatch(setIsApplicationTypeOthers(false));
        }
      }
      else
      {
        hideLoader();
        notify(ToastType.Error, insertData.Message);
      }
      // } else {
      //   hideLoader();
      //   selectNextTab();
      // }
    }
    setError(errorObj);
  };

  const getPersonalDetails = async () => {
    if (memberid != null && memberid != "") {
      showLoader();
      let param = `${getPersonalDetailsByMemberId}`;
      let requestBody = { MemberId: memberid };
      const insertData = await APICall(param, requestBody);
      // return insertData.Data;
     
      if (insertData.Data != null) {
        let applicantType = applicantTypeDropData.find((d) => d.value === insertData.Data.ApplicantType);

        if (applicantType && (applicantType.label.includes("Other") || applicantType.label.includes("other"))) {
          dispatch(setIsApplicationTypeOthers(true));
        } else {
          dispatch(setIsApplicationTypeOthers(false));
        }

        //tmp solution
        let regionSelected = regionDropData.find((d) => d.value === insertData.Data.Region);
        if (!regionSelected) {
          regionSelected = stateDropData.find((d) => d.value === insertData.Data.Region);
        }

        let data = {
          tokenNumber: Number(insertData.Data.TokenNo),
          typeOfApplicant: applicantTypeDropData.find((d) => d.value === insertData.Data.ApplicantType),
          firstName: insertData.Data.FirstName,
          middleName: insertData.Data.MiddleName,
          lastName: insertData.Data.LastName,
          dob: moment(insertData.Data.DOB, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
          doj: moment(insertData.Data.DOJ, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
          doc: moment(insertData.Data.DOC, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
          mobileNumber: insertData.Data.ContactNo,
          email: insertData.Data.EmailId,
          //New
          title: titleDropData.find((d) => d.value === insertData.Data.Title),
          gender: genderDropData.find((d) => d.value === insertData.Data.Gender),
          maritialStatus: maritialStatusDropData.find((d) => d.value === insertData.Data.MaritialStatus),
          birthCity: insertData.Data.BirthCity,
          state: stateDropData.find((d) => d.value === insertData.Data.State),
          nationality: nationalityDropData.find((d) => d.value === insertData.Data.Nationality),
          religion: religionDropData.find((d) => d.value === insertData.Data.Religion),
          serviceYears: insertData.Data.ActualServiceYears,
          careOf: insertData.Data.CareOf,
          street: insertData.Data.Street,
          secondAddLine: insertData.Data.AddLineSecond,
          postalCode: insertData.Data.PostalCode,
          district: insertData.Data.District,
          region: regionSelected, //regionDropData.find((d) => d.value === insertData.Data.Region),
          country: countryDropData.find((d) => d.value === insertData.Data.Country),
        };
        setData(data);
        setDisabledToken(true);
        if ([ApplicationStatus.MemberRegistrationModule_Draft, ApplicationStatus.MemberRegistrationModule_RejectedHRHOD].includes(insertData.Data.StatusId)) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
        if (data.typeOfApplicant) {
          dispatch(setMemberRegistrationUserType(data.typeOfApplicant));
        }
        hideLoader();
      }

      return insertData.Data;
    } else {
      setDisabledToken(false);
    }
  };

  const getTitleData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Title,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setTitleDropData(result.Data);
    }
  };

  const getGenderData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Gender,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setGenderDropData(result.Data);
    }
  };

  const getMaritialStatusData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.MaritialStatus,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setMaritialStatusDropData(result.Data);
    }
  };

  const getReligionData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Religion,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setReligionDropData(result.Data);
    }
  };

  const getRegionData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Region,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setRegionDropData(result.Data);
    }
  };

  const getStateData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.State,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setStateDropData(result.Data);
    }
  };

  const getCountryData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Country,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setCountryDropData(result.Data);

      const filteredData = result.Data.filter((item) => item.label.toLowerCase() === "INDIA".toLowerCase());
      setData({ ...data, country: filteredData });

      // country
      // data.country
    }
  };

  const getNationalityData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Nationality,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setNationalityDropData(result.Data);
    }
  };

  const getApplicantTypeData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.ApplicantType,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setApplicantTypeDropData(result.Data);
    }
  };

  const getMultipleDropdownData = async () => {
    const requestBody = {
      dropdowns: [
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Title,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Gender,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.MaritialStatus,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Religion,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Region,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.State,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Country,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.Nationality,
        },
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.ApplicantType,
        },
      ],
    };

    const result = await APICall(GetMultipleDropdownData, requestBody);

    if (result && result.Status === ApiStatus.OK) {
      let mdData = result.Data as Array<GetMultipleDropdownDataResponseModel>;

      for (let index = 0; index < mdData.length; index++) {
        const md = mdData?.[index];
        if (md) {
          switch (md.Name) {
            case "generic":
              switch (md.GenericMasterTypeId) {
                case DropdownTypeId.Title:
                  setTitleDropData(md.Data);
                  break;
                case DropdownTypeId.Gender:
                  setGenderDropData(md.Data);
                  break;
                case DropdownTypeId.MaritialStatus:
                  setMaritialStatusDropData(md.Data);
                  break;
                case DropdownTypeId.Religion:
                  setReligionDropData(md.Data);
                  break;
                case DropdownTypeId.Region:
                  setRegionDropData(md.Data);
                  break;
                case DropdownTypeId.State:
                  setStateDropData(md.Data);
                  break;
                case DropdownTypeId.Country:
                  setCountryDropData(md.Data);
                  break;
                case DropdownTypeId.Nationality:
                  setNationalityDropData(md.Data);
                  break;
                case DropdownTypeId.ApplicantType:
                  setApplicantTypeDropData(md.Data);
                  break;
              }
              break;
          }
        }
      }
    }
  };

  //console.log(data);
  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    // Your target date
    let doj = moment(randomDate(new Date(1990, 1, 1), new Date(2010, 1, 1))).format("YYYY-MM-DD");
    const targetDate = moment(doj, "YYYY-MM-DD");

    // Current date
    const currentDate = moment();

    // Calculate the number of years
    const years = currentDate.diff(targetDate, "years");

    // Round up to the nearest whole number
    const roundedYears = Math.ceil(years);

    let newData = {
      tokenNumber: randomNumber(9999, 99999),
      typeOfApplicant: applicantTypeDropData[randomNumber(0, applicantTypeDropData.length - 1)],
      firstName: randomString(10),
      middleName: randomString(10),
      lastName: randomString(10),
      dob: moment(randomDate(new Date(1970, 1, 1), new Date(1990, 1, 1))).format("YYYY-MM-DD"),
      doj: doj,
      doc: moment(randomDate(new Date(2010, 1, 1), new Date(2011, 1, 1))).format("YYYY-MM-DD"),
      mobileNumber: randomMobile(),
      email: randomEmail(),
      //New
      title: titleDropData[randomNumber(0, titleDropData.length - 1)],
      gender: genderDropData[randomNumber(0, genderDropData.length - 1)],
      maritialStatus: maritialStatusDropData[randomNumber(0, maritialStatusDropData.length - 1)],
      birthCity: randomString(10),
      state: stateDropData[randomNumber(0, stateDropData.length - 1)],
      nationality: nationalityDropData[randomNumber(0, nationalityDropData.length - 1)],
      religion: religionDropData[randomNumber(0, religionDropData.length - 1)],
      serviceYears: roundedYears,
      careOf: randomString(10),
      street: randomString(10),
      secondAddLine: randomString(10),
      postalCode: "" + randomNumber(6, 6),
      district: randomString(10),
      region: regionDropData[randomNumber(0, regionDropData.length - 1)],
      country: countryDropData[randomNumber(0, countryDropData.length - 1)],
    };
    setData(newData);
  };

  return (
    <div className="">
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row" style={{ marginLeft: "0px", marginRight: "0px" }}>
          <div className="col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-center" style={{ marginTop: "15px", background: "#F6ECED" }}>
            <div
              className="col-lg-4 col-sm-4 col-xs-4 "
              style={{
                marginTop: "15px",
                background: "#F6ECED",
                padding: "15px",
              }}
            >
              <div className="form-group">
                <label onDoubleClick={() => testData()}>Token Number</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.tokenNumber}
                  maxlength="5"
                  onChange={(val: any) => {
                    let value = val.target.value;
                    const regex = /^[0-9\b]/;
                    if (value === "" || regex.test(value)) {
                      if (value.length > 10) {
                        value = value.slice(0, 10);
                      }
                      onChange("tokenNumber", value);
                    }
                  }}
                  isDisabled={disabledToken}
                  type="number"
                  onKeyPress={(e) => handleKeyPress(e)}
                  onWheel={(e) => e.target.blur()}
                />
                {error[data.tokenNumber] && <p style={{ color: "red" }}>{error[data.tokenNumber]}</p>}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Type of Applicant</label>
            <sup>*</sup>
            <SelectForm
              value={data.typeOfApplicant}
              placeholder="Type Of Applicant"
              options={applicantTypeDropData}
              isDisabled={disabled}
              onChange={(val: any) => onChange("typeOfApplicant", val)}
            />
            {error[data.typeOfApplicant] && <p style={{ color: "red" }}>{error[data.typeOfApplicant]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Title</label>
            <sup>*</sup>
            <SelectForm value={data.title} placeholder="Title" options={titleDropData} isDisabled={disabled} onChange={(val: any) => onChange("title", val)} />
            {error[data.title] && <p style={{ color: "red" }}>{error[data.title]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>First Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.firstName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("firstName", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.firstName] && <p style={{ color: "red" }}>{error[data.firstName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Middle Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.middleName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("middleName", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.middleName] && <p style={{ color: "red" }}>{error[data.middleName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Last Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.lastName}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("lastName", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.lastName] && <p style={{ color: "red" }}>{error[data.lastName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Gender</label>
            <sup>*</sup>
            <SelectForm
              value={data.gender}
              placeholder="Gender"
              options={genderDropData}
              isDisabled={disabled}
              onChange={(val: any) => {
               
                onChange("gender", val);
              }}
            />
            {error[data.gender] && <p style={{ color: "red" }}>{error[data.gender]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date Of Birth</label>
            <sup>*</sup>
            <DateForm
              isDisabled={disabled}
              value={data.dob}
              onChange={(val: any) => {
                onChange("dob", val);
                // onChange("doj", null)
              }}
              placeholder="DD-MM-YYYY"
              disableFuture={true}
              maxDate={moment().subtract(2, "day")}
            />
            {error[data.dob] && <p style={{ color: "red" }}>{error[data.dob]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Maritial Status</label>
            <sup>*</sup>
            <SelectForm
              value={data.maritialStatus}
              placeholder="Maritial Status"
              options={maritialStatusDropData}
              isDisabled={disabled}
              onChange={(val: any) => onChange("maritialStatus", val)}
            />
            {error[data.maritialStatus] && <p style={{ color: "red" }}>{error[data.maritialStatus]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Place of Birth</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.birthCity}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("birthCity", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[data.birthCity] && <p style={{ color: "red" }}>{error[data.birthCity]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>State</label>
            <sup>*</sup>
            <SelectForm value={data.state} placeholder="State" options={stateDropData} isDisabled={disabled} onChange={(val: any) => onChange("state", val)} />
            {error[data.state] && <p style={{ color: "red" }}>{error[data.state]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Nationality</label>
            <sup>*</sup>
            <SelectForm
              value={data.nationality}
              placeholder="Nationality"
              options={nationalityDropData}
              isDisabled={disabled}
              onChange={(val: any) => onChange("nationality", val)}
            />
            {error[data.nationality] && <p style={{ color: "red" }}>{error[data.nationality]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Religion</label>
            <sup>*</sup>
            <SelectForm
              value={data.religion}
              placeholder="Religion"
              options={religionDropData}
              isDisabled={disabled}
              onChange={(val: any) => onChange("religion", val)}
            />
            {error[data.religion] && <p style={{ color: "red" }}>{error[data.religion]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Joining</label>
            <sup>*</sup>
            <DateForm
              isDisabled={disabled}
              value={data.doj}
              onChange={(val: any) => onChange("doj", val)}
              placeholder="DD-MM-YYYY"
              disableFuture={true}
              maxDate={moment()}
              minDate={moment(data.dob).add(18, "years")} // Calculate the minimum date based on DOB
            />
            {error[data.doj] && <p style={{ color: "red" }}>{error[data.doj]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Actual Year of Service</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.serviceYears}
              onChange={(val: any) => {
                
                // let value = val.target.value;

                // const regex = /^[0-9\b]/;
                // if (value === "" || regex.test(value)) {
                //   if (value.length > 3) {
                //     value = value.slice(0, 3);
                //   }
                //   onChange("serviceYears", value);
                // }

                //  const regex = /^(?:[1-9][0-9]*|0)$/ ///^[0-9\b]/;
                // onChange("mobileNumber", value);
              }}
              maxlength="3"
              type="number"
              // onKeyPress={(e) => handleKeyPress(e)}
              isDisabled={true}
              // onWheel={(e) => e.target.blur()}
            />
            {/* {error[data.serviceYears] && <p style={{ color: "red" }}>{error[data.serviceYears]}</p>} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Care of</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.careOf}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("careOf", value);
              }}
              isDisabled={disabled}
              maxLength={200}
            />
            {error[data.careOf] && <p style={{ color: "red" }}>{error[data.careOf]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Street/House</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.street}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("street", value);
              }}
              isDisabled={disabled}
              maxLength={200}
            />
            {error[data.street] && <p style={{ color: "red" }}>{error[data.street]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>2nd add line</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.secondAddLine}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("secondAddLine", value);
              }}
              isDisabled={disabled}
              maxLength={200}
            />
            {error[data.secondAddLine] && <p style={{ color: "red" }}>{error[data.secondAddLine]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Postal Code</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.postalCode}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9\b]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 6) {
                    value = value.slice(0, 6);
                  }
                  onChange("postalCode", value);
                }
              }}
              type="number"
              maxLength={6}
              onKeyPress={(e) => handleKeyPress(e)}
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
            {error[data.postalCode] && <p style={{ color: "red" }}>{error[data.postalCode]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>District</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.district}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("district", value);
              }}
              isDisabled={disabled}
              maxLength={200}
            />
            {error[data.district] && <p style={{ color: "red" }}>{error[data.district]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Region</label>
            <sup>*</sup>
            <SelectForm value={data.region} placeholder="Region" options={regionDropData} isDisabled={true} onChange={(val: any) => onChange("region", val)} />
            {/* {error[data.region] && <p style={{ color: "red" }}>{error[data.region]}</p>} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Country</label>
            <sup>*</sup>
            <SelectForm
              value={data.country}
              placeholder="Country"
              options={countryDropData}
              isDisabled={disabled}
              onChange={(val: any) => onChange("country", val)}
            />
            {error[data.country] && <p style={{ color: "red" }}>{error[data.country]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Confirmation</label>
            <sup>*</sup>
            <DateForm
              isDisabled={disabled}
              value={data.doc}
              onChange={(val: any) => onChange("doc", val)}
              placeholder="DD-MM-YYYY"
              disableFuture={true}
              maxDate={moment()}
              minDate={moment(data.dob)}
            />
            {error[data.doc] && <p style={{ color: "red" }}>{error[data.doc]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.mobileNumber}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9\b]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  onChange("mobileNumber", value);
                }

                //  const regex = /^(?:[1-9][0-9]*|0)$/ ///^[0-9\b]/;
                // onChange("mobileNumber", value);
              }}
              maxlength="10"
              type="number"
              onKeyPress={(e) => handleKeyPress(e)}
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
            {error[data.mobileNumber] && <p style={{ color: "red" }}>{error[data.mobileNumber]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.email}
              onChange={(val: any) => {
                let value = val.target.value;
                let regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                if (value && !validator.isEmail(value)) {
                  setError({
                    ...error,
                    emailvalidation: "Please enter a valid email",
                  });
                } else {
                  setError({ ...error, emailvalidation: "" });
                }
                onChange("email", value);
              }}
              isDisabled={disabled}
              maxLength={50}
            />
            {error["emailvalidation"] ? <p style={{ color: "red" }}>{error["emailvalidation"]}</p> : null}
            {data.typeOfApplicant?.value === MemberRegistrationUserType.Officers && (
              <div className="note-text">{`Note: Please mention your email ID as <token number>@mahindra.com.`}</div>
            )}
          </div>
        </div>
      </div>
      <div className="p-2 d-flex justify-content-end" style={{ marginTop: 20 }}>
        <ButtonComponent icon={"far fa-times-circle"} value={"Exit"} style={{ marginLeft: "10px" }} className="btn btn-primary" onClick={() => navigate("/")} />
        <ButtonComponent
          icon={"fas fa-arrow-right"}
          value={disabled ? "Next" : "Save & Next"}
          style={{ marginLeft: "10px" }}
          id={"saveBtn"}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};

export default PersonalDetails;
